<div *ngIf="breadcrumb$ | async as breadcrumb" class="max-w-xs menu flex flex-col h-full justify-between border border-gray-200">
  <ul id="app-main-menu" class="flex-1">
    <li *ngFor="let item of menu | keyvalue:sortByOrder"
        class="py-2 pl-4 pr-8 w-full hover:bg-gray-50"
        [attr.data-app]="item.key"
        [ngClass]="{
          'bg-gray-200': item.key === breadcrumb[0].label
        }"
    >
      <a (click)="navigate(item.value.link); $event.preventDefault();" [routerLink]="(item.key !== breadcrumb[0].label) ? item.value.link : null" class="flex cursor-pointer">
        <img src="/assets/img/apps/{{ item.key }}.svg"
             class="inline-block w-auto h-6"
        >
        <!-- <span class="uppercase mr-3 font-bold theme-{{ item.key }}"></span> -->
        <span class="text-gray-main-menu ml-0 my-auto">
          {{ ('menu.' + item.key + '.subtitle') | translate }}
        </span>
      </a>
    </li>
  </ul>
  <!-- <pre class="overflow-auto text-xs"> 
    {{ breadcrumb | json }}
  </pre> -->
  <div class="flex flex-col flex-initial">
    <div class="border-t">
      <ul *ngIf="breadcrumb[0] && breadcrumb[1]">
        <li *ngFor="let subitem of menu[breadcrumb[0].label]?.items | keyvalue:sortByOrder" [@fadeIn]
            class="py-2 pl-4 pr-8 w-full border-b border-gray-300 hover:bg-gray-50"
            [attr.data-app-section]="subitem.key"
            [ngClass]="{
              'bg-gray-200': (breadcrumb[1].label === subitem.key)
            }"
        >
          <a *ngIf="breadcrumb[1]"
              (click)="navigate(subitem.value.link); $event.preventDefault();"
              [routerLink]="(breadcrumb[1].label === subitem.key) ? null : subitem.value.link"
              class="flex cursor-pointer"
          >
            <span class="mr-1 dx-theme-accent-as-text-color"><span icon="more_horiz"></span></span>
            <span class="my-auto">{{ ('menu.' + breadcrumb[0].label + '.zones.' + subitem.key) | translate }}</span>
          </a>
        </li>
      </ul>

    </div>
    <div class="flex flex-initial m-4">
      <div id="glamLogo"
           class="mr-auto w-1/2"
           (mouseenter)="visible = !visible"
           (mouseleave)="visible = !visible"
      >
        <img src="/assets/img/logo/logo_color_glam_dark.png">
      </div>
      <div class="ml-1 text-xs justify-center">v {{ version }}</div>
    </div>
  </div>
</div>
<dx-tooltip target="#glamLogo" [(visible)]="visible">
  <div *dxTemplate="let data = data; of: 'content'">
    <div class="font-bold">{{ 'technicalSupport' | translate | ucfirst }}</div>
    <div><a href="mailto:{{ mail }}">{{ mail }}</a></div>
    <div><a href="tel:{{ phone }}">{{ phone }}</a></div>
  </div>
</dx-tooltip>
<!-- this empty div allows the drawer to be rendered even if the breadcrumb is not yet available -->
<div>&nbsp;</div>
